import { gql } from "@apollo/client";

export const removeReportsQuery = gql`
mutation removeReportsQuery($ids: [String!]!) {
  removeReports(ids: $ids) {
    success
  }
}
`;
